export default function MyDashboard() {
  if (document.readyState !== "loading") {
    myDashboardInit();
  } else {
    document.addEventListener("DOMContentLoaded", myDashboardInit);
  }
}

function myDashboardInit() {
  const closableBlocks = document.querySelectorAll(
    ".js-my-dashboard__closable-block"
  );

  const handleCloseBlock = (block) => {
    if (!block.dataset.storageKey) return;

    sessionStorage.setItem(block.dataset.storageKey, true);
    block.style.display = "none";
  };

  closableBlocks.forEach((block) => {
    const button = block.querySelector(".my-dashboard__block-button-close");

    if (!sessionStorage.getItem(block.dataset.storageKey)) {
      block.style.display = "flex";
    }

    if (button) {
      button.addEventListener("click", () => handleCloseBlock(block));
    }
  });
}
